import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

export const usePatients = () => {
    const [patients, setPatients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPatients = async () => {
            try {
                const response = await apiFetch('/api/patients');
                if (!response.ok) {
                    throw new Error('Failed to fetch patients');
                }
                const data = await response.json();
                const patientOptions = data.map(patientId => ({
                    id: patientId,
                    label: patientId
                }));
                setPatients(patientOptions);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPatients();
    }, []);

    return { patients, loading, error };
}; 
